import React from 'react';
import { admissionAreaGuide } from '../../config';

const KhuVucUuTienGuide = () => {
  const borderColors = {
    blue: '#3b82f6',
    green: '#10b981',
    yellow: '#f59e0b',
    red: '#ef4444'
  };

  return (
    <div style={{
      backgroundColor: '#eff6ff',
      border: '1px solid #bfdbfe',
      borderRadius: '8px',
      padding: '20px',
      marginBottom: '24px'
    }}>
      <h3 style={{
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#1e40af',
        marginBottom: '16px',
        marginTop: 0
      }}>
        Hướng dẫn: Khu vực ưu tiên (theo Phụ lục I)
      </h3>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {Object.entries(admissionAreaGuide).map(([code, info]) => (
          <div 
            key={code}
            style={{
              borderLeft: `4px solid ${borderColors[info.color]}`,
              paddingLeft: '16px'
            }}
          >
            <p style={{ 
              fontWeight: '600', 
              marginBottom: '4px',
              marginTop: 0,
              color: '#1f2937'
            }}>
              {info.label}
            </p>
            <p style={{
              fontSize: '14px',
              color: '#374151',
              marginTop: '4px',
              marginBottom: 0,
              lineHeight: '1.5'
            }}>
              {info.description}
            </p>
          </div>
        ))}
      </div>

      <p style={{
        fontSize: '14px',
        color: '#6b7280',
        marginTop: '16px',
        marginBottom: 0,
        fontStyle: 'italic'
      }}>
        Lưu ý: Bạn cần chọn đúng khu vực ưu tiên theo Khu vực của trường THPT.
      </p>
    </div>
  );
};

export default KhuVucUuTienGuide;
